var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.101562 6.5C0.101562 7.32031 0.671875 7.85937 1.53125 7.85937L9.34375 7.85937L11.0312 7.78906L9.64844 8.94531L7.89844 10.6953C7.64062 10.9453 7.45312 11.25 7.45312 11.6719C7.45312 12.3984 7.98437 12.9531 8.76562 12.9531C9.11719 12.9531 9.46094 12.8125 9.73437 12.5312L14.7734 7.5C15.0156 7.25781 15.1719 6.86719 15.1719 6.5C15.1719 6.13281 15.0156 5.74219 14.7734 5.5L9.73437 0.46875C9.46094 0.195312 9.11719 0.0468746 8.76562 0.0468746C7.98437 0.0468746 7.45312 0.601562 7.45312 1.33594C7.45312 1.75 7.64062 2.0625 7.89844 2.3125L9.64844 4.04687L11.0312 5.21094L9.34375 5.13281L1.53125 5.13281C0.671875 5.13281 0.101562 5.67969 0.101562 6.5Z",
    fill: "#0A1620"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNext);
export default __webpack_public_path__ + "static/media/arrow-next.6f73d44d465d6dc3d8fe31068b2f38fb.svg";
export { ForwardRef as ReactComponent };